import { render, staticRenderFns } from "./collectRatingScale.vue?vue&type=template&id=9488a8f0&scoped=true"
import script from "./collectRatingScale.vue?vue&type=script&lang=js"
export * from "./collectRatingScale.vue?vue&type=script&lang=js"
import style0 from "./collectRatingScale.vue?vue&type=style&index=0&id=9488a8f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9488a8f0",
  null
  
)

export default component.exports